import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function SubTasksTemplatesAPI(): BringozApi {
  return {
    base: `/subTasks/templates`,
    infiniteScroll: {
      address: `/subTasks/templates`,
      cmd: 'GET'
    },
    actions: {
      getTemplates: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getTemplateActions: {
        address: 'actions',
        cmd: 'GET',
        updateable: true
      },
      createTemplate: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      updateTemplate: {
        address: '{templateId}',
        cmd: 'POST',
        updateable: true
      },
      deleteTemplate: {
        address: '{templateId}',
        cmd: 'DELETE',
        updateable: true,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }
  }
}
angular
  .module('bringoz.admin.sub-tasks')
  .factory('SubTasksTemplatesAPI', SubTasksTemplatesAPI);
